
import React, { useEffect, useMemo, useState } from 'react'
import { Plus } from 'lucide-react'
import { AvatarCharecter, AvatarImage, Card, CardContent, LargeModal, Tabs } from 'components'
import { EProjectActions, IItemTab } from 'types'
import Sprint from './components/details/Sprint'
import Tags from './components/details/Tags'
import ContentDetail from './components/details/ContentDetail'
import { useApp, useProject } from 'hooks'
import { useParams } from 'react-router-dom'
import Attachment from './components/attachment/Attachment'
import { formatBytes, formatDMYHMSInd, repareStorageURL } from 'utils'

export default function ProjectDetail() {

    const { dataSprints, dataTags, projectIsFetch, onUpdateParams } = useApp();
    const { id } = useParams();
    console.log("🚀 ~ ProjectDetail ~ id:", id)
    const [item, setItem] = useState(null);
    const [action, setAction] = useState('')


    const { fetchDataDetail, attachmentProj } = useProject();

    const { data } = fetchDataDetail(id, projectIsFetch);

    useEffect(() => {
        if (data?.data) {
            const project = data.data;
            console.log("🚀 ~ ProjectDetail ~ project:", project)
            setItem(project)
            onUpdateParams({ projectDetail: project })
        }
    }, [data?.data]);

    const itemTab: IItemTab[] = useMemo(() => [
        {
            label: 'Chi tiết',
            content: <ContentDetail />,
        },
        {
            label: 'Phiên bản',
            content: <Sprint />
        },
        {
            label: 'Thẻ',
            content: <Tags />
        },
    ], [JSON.stringify(item || ''), dataSprints, dataTags]);

    const handleActions = (act) => {
        switch (act) {
            case EProjectActions.ATTACHMENT:

                setAction(act)
                break;

            default:
                break;
        }
    }

    const onClose = (ifs = false) => {
        setAction(null);
        ifs && onUpdateParams({ projectIsFetch: !projectIsFetch })
    }

    const onConfirmAttachment = (payload: { file: File, title: string, content: string; }) => {
        console.log("🚀 ~ onConfirmAttachment ~ files:", payload)
        if (payload?.title) {
            attachmentProj.mutate({ id: data?.data?.id, ...payload }, {
                onSuccess: () => {
                    onClose(true);
                }
            });
            return;
        }
        onClose();
    }

    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mx-auto">
            {/* Left side (2/3) */}
            <div className="lg:col-span-2 space-y-3">

                <Card>
                    <CardContent className="p-6 space-y-3">
                        <Tabs tabs={itemTab} />
                    </CardContent>
                </Card>
                {/* Comments */}
                {/* <Card>
                    <CardContent className="p-6 space-y-3">
                        <Feed />
                    </CardContent>
                </Card> */}
            </div>

            {/* Right side (1/3) */}
            <div className="space-y-3">
                {/* Progress */}
                {/* <Card>
                    <CardContent className="p-6">
                        <div className="font-medium text-gray-800 mb-4">Progress</div>
                        <div className="h-40 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 text-sm">
                            [Chart Placeholder]
                        </div>
                    </CardContent>
                </Card> */}

                {/* Files */}
                <Card>
                    <CardContent className="p-6 space-y-4">
                        <div className="flex justify-between items-center mb-2">
                            <div className="font-medium text-gray-800">Files & Tài liệu</div>
                            <button onClick={() => handleActions(EProjectActions.ATTACHMENT)} className=" bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors text-sm">
                                <div className="justify-center flex items-center">
                                    <Plus className="w-4 h-4" />
                                </div>
                            </button>
                        </div>
                        {!!item?.files?.length && item.files.map((f, i) => (
                            <div key={i} className="flex justify-between items-center p-3 border rounded-md border-gray-200">
                                <div className="flex items-start gap-3">
                                    {/* <FileText className="w-5 h-5 text-blue-500" /> */}
                                    {f?.avatar ? <AvatarImage src={repareStorageURL(`${f?.avatar}`)} alt={f?.name} className="w-8 h-8 rounded-full" /> : <AvatarCharecter className="w-8 h-8" name={f?.name} />}
                                    <div className='space-y-2'>
                                        <div className="text-sm font-medium">{f.title}</div>
                                        <div className="text-xs text-gray-400">Cập nhật: {formatDMYHMSInd(f.created_at, "-")}</div>
                                        <span className="text-sm text-gray-500" dangerouslySetInnerHTML={{ __html: f.content }}></span>
                                        {f.path && <div className="flex items-center gap-4">
                                            {/* <FileText className="w-5 h-5 text-blue-500" /> */}
                                            <AvatarImage src={repareStorageURL(f.path)} alt={f.name} style={{ maxWidth: 90, border: '1px solid #ccc' }} />
                                            <div>
                                                <div className="text-sm font-medium">{f.name}</div>
                                                <div className="text-xs text-gray-500">{formatBytes(f.size)}</div>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </CardContent>
                </Card>
            </div>
            {[`${EProjectActions.ATTACHMENT}`].includes(action) && <LargeModal title={`Đính kèm file`} onClose={onClose} >
                <Attachment onClose={onClose} onConfirm={e => {
                    onConfirmAttachment(e)
                }} />
            </LargeModal>}
        </div>
    )
}
